module.exports = __webpack_public_path__ + "static/media/elephantTutF.800e19ab.jpg";